<template>
  <div class="cpt-welcome">
    <img class="back-img" src="../assets/home-bg2.png" v-if="!userAgent" alt="">
    <div :class="userAgent ? 'content-box-m' : 'content-box'">
      <div class="content">
        <div class="content-img">
          <img src="../assets/home-bg3.png" v-if="!userAgent" alt="">
          <img src="../assets/home-bg3-m.png" v-if="userAgent" alt="">
        </div>
        <div class="content-text">
          <div class="title-en tit-en" v-if="$i18n.locale == 'zh-CN'">{{ welcomeData.titleEn }}</div>
          <div class="title tit">{{ welcomeData.title }}</div>
          <div class="box-boder"></div>
          <div :class="$i18n.locale == 'en-US' ? 'text-en' : 'text'">{{ welcomeData.text }}</div>
          <div class="more">
            <router-link to="/about">
              <div class="view-more">
                <div class="text">{{ $t('acm_learn_more') }}</div>
                <img class="icon" src="../assets/arrow-white.png" alt="">
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cpt-welcome',
  data() {
    return {
      welcomeData: this._contentData.welcomeData,
      userAgent: this.$utils.isMobile()
    }
  },
  created() {
  },
  methods: {
  },
}

</script>

<style lang='scss' scoped>
.cpt-welcome{
  position: relative;
  min-height: 480px;
  background: #fff;
  .back-img{
    width: 100%;
  }
  .content-box{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    position: absolute;
    bottom: 0;
    left: 0;
    .content{
      background: #407ea0;
      width: 1200px;
      height: 480px;
      display: flex;
      justify-content: flex-end;
      position: relative;
      .content-img{
        position: absolute;
        bottom: 55px;
        left: 40px;
        img{
          width: 100%;
        }
        // margin-left: 40px;
        // margin-bottom: 55px;
      }
      .content-text{
        width: 550px;
        // position: relative;
        // top: 0;
        // right: 0;
        margin: 40px 50px;
        .tit-en{
          color: rgba(255, 255, 255, 0.3);
        }
        .tit{
          color: #fff;
        }
        .box-boder{
          width: 70px;
          height: 3px;
          background: #fff;
          margin: 15px 0 35px;
        }
        .text{
          font-size: 22px;
          color: #fff;
          // font-family: MiSans-Normal;
        }
        .text-en{
          font-size: 20px;
          color: #fff;
          // font-family: MiSans-Normal;
        }
        .more{
          .view-more{
            border: 1px solid #fff;
            display: flex;
            width: max-content;
            margin-top: 48px;
            .text{
              color: #407ea0;
              font-size: 18px;
              // font-family: MiSans-Normal;
              background: #fff;
              padding: 10px 30px;
            }
            .icon{
              background: #407ea0;
              width: 50px;
              padding: 10px;
            }
          }
        }
      }
    }
  }
  .content-box-m{
    padding: 30px 15px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    // position: absolute;
    // bottom: 0;
    // left: 0;
    .content{
      // width: 1300px;
      // height: 0px;
      display: flex;
      justify-content: flex-end;
      position: relative;

      .content-img{
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        display: flex;
        justify-content: center;
        img{
          width: 320px;
        }
      }
      .content-text{
        // width: 600px;
        // position: relative;
        // top: 0;
        // right: 0;
        // margin: 60px 50px;
        margin-top: 120px;
        padding: 120px 40px 30px;
        background: #407ea0;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        .tit-en{
          color: rgba(255, 255, 255, 0.3);
          text-align: center;
        }
        .tit{
          color: #fff;
          text-align: center;
        }
        .box-boder{
          width: 30px;
          height: 1px;
          background: #fff;
          margin: 10px 0 15px;
          text-align: center;
        }
        .text{
          font-size: 9px;
          color: #fff;
          // font-family: MiSans-Normal;
        }
        .text-en{
          font-size: 9px;
          color: #fff;
          // font-family: MiSans-Normal;
        }
        .more{
          margin-top: 25px;
          display: flex;
          justify-content: center;
          .view-more{
            border: 1px solid #fff;
            display: flex;
            width: max-content;
            .text{
              color: #407ea0;
              font-size: 10px;
              // font-family: MiSans-Normal;
              background: #fff;
              padding: 5px 10px;
            }
            .icon{
              background: #407ea0;
              height: 12px;
              padding: 5px;
            }
          }
        }
      }
    }
  }
}
</style>